import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

const columns: GridColDef[] = [
  { field: "id", headerName: "Id", width: 110,headerAlign: "center", align : "center",},
  { field: "residue", headerName: "Residue", width: 400, headerAlign: "center" , align : "center" },
];

type MissingResiduesPanelProps = {
  residues: string[];
};

export default function MissingResiduesPanel({ residues }: MissingResiduesPanelProps) {
  const rows = residues.map((residue, index) => ({
    id: index + 1,
    residue,
  }));

  return (
    <Box my={2}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">
            Missing Residues ({residues.length})
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ height: "auto", width: "100%" }}>
            <DataGridPro
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 5 },
                },
              }}
              pageSizeOptions={[5, 10]}
              disableRowSelectionOnClick
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
